import { Component } from '@verndale/core';
import Cookies from 'js-cookie';
import * as Coveo from 'coveo-search-ui';
import { getTimesConfig, buildOptionsHtml } from '../helpers/times';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $topics: this.el._$('.community-contact-us__topics'),
      $communityInput: this.el._$('.community-contact-us__community input'),
      $form: this.el._$('.community-contact-us__form'),
      $communityZip: this.el._$('.community-contact-us__zip'),
      $contextCommunityInput: this.el._$(
        '.community-contact-us__community-context input'
      ),
      $communityDistance: this.el._$(
        '.community-contact-us__community-distance input'
      ),
      $datePicker: this.el._$('duet-date-picker'),
      $timeSelect: this.el._$('.community-contact-us__time select'),
      $communityColumns: this.el._$('.community-contact-us__cols'),
      $submitButton: this.el._$('.community-contact-us__submit')
    };
    this.closedQuery = false
    this.isSecondQuery = false
    this.metersToMiles = 0.000621371
    this.meters = 1609.34;
    this.apiKey = this.el.dataset.apiK;
    this.preferredTimesTopicValue = this.el.dataset.preferredTimesTopic;
    this.preferredTimesShownClass =
      'community-contact-us--preferred-times-shown';

    if (this.dom.$datePicker) {
      this.dom.$datePicker.firstDayOfWeek = 0;
      this.timeHandler();
    }

    this.verifyQueryParams();

    if (this.dom.$communityZip) {
      this.contextCommunity = Cookies.get('current_community') || this.el.dataset.contextCommunity;
      this.configureEndpoint();
      Coveo.init(this.el);
      Coveo.Logger.disable();
      this.alterQuery();
      this.getResults();
    }

    this.fixMac();
  }

  fixMac() {
    if (navigator.userAgent.indexOf('Win') !== -1) {
      this.dom.$communityColumns?.classList.add('windows--screen');
    }
  }

  timeHandler() {
    this.dom.$timeSelect.innerHTML = '';

    const todayFormated = new Date().toLocaleString('sv', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).split(' ')[0].split('/').reverse().join('-');
    const isToday = this.dom.$datePicker.value === todayFormated;
    const today = new Date().toLocaleString('en-US', { timeZone: 'America/New_York' });

    const { parsedOptions, minDatePicker } = getTimesConfig(this.dom.$datePicker, isToday, today);
    this.dom.$datePicker.min = minDatePicker;

    if (parsedOptions.length === 1) {
      const $dateInput = this.dom.$datePicker.querySelector('.duet-date__input');
      const errorMessage = this.dom.$datePicker.dataset.pristineNoTimes;
      setTimeout(() => {
        $dateInput.pristine.errors = [];
        $dateInput.pristine.self.addError($dateInput, errorMessage);
      });
    }

    const optionsHtml = buildOptionsHtml(parsedOptions);

    this.dom.$timeSelect.innerHTML = optionsHtml;
  }

  alterQuery() {
    Coveo.$$(this.el).on('buildingQuery', (e, args) => {
      if (this.lat && this.long) {
        args.queryBuilder.addFieldsToInclude([
          'ssl_latitude_d',
          'ssl_longitude_d',
          'ssl_communityid',
          'distance'
        ]);

        const expression = this.getGeoQuery(this.lat, this.long);
        const $masthead = document.querySelector('.masthead-with-zipcode');
        const mastheadRadius = $masthead?.dataset.formRadius;
        const radius = Math.round(($masthead && mastheadRadius) ? mastheadRadius * this.meters : this.el.dataset.formRadius * this.meters);
        const source = this.el.dataset.source;
        const language = this.el.dataset.contextLanguage;
        args.queryBuilder.advancedExpression.add(expression);
        if (this.isSecondQuery) {
          if (this.contextCommunity) {
            const parsedContextCommunity = JSON.parse(this.contextCommunity).ssl_communityid.slice(1, -1);
            args.queryBuilder.advancedExpression.add(`@ssl_communityid=='${parsedContextCommunity}'`);
          }
          this.closedQuery = true
        } else {
          args.queryBuilder.advancedExpression.add(`@distance<=${radius}`);
        }
        args.queryBuilder.sortCriteria = '@distance Ascending';
        args.queryBuilder.advancedExpression.add(
          "@ssl_pagetype=='community_pagetype'"
        );
        if (source) {
          args.queryBuilder.advancedExpression.add(`@source=="${source}"`);
        }

        if (language) {
          args.queryBuilder.advancedExpression.add(
            `@ssl_contextlanguage=="${language}"`
          );
        }
      }
    });
  }

  showZipError() {
    const zipCode = this.dom.$form.querySelector('[name="zipCode"]');
    const nearbyCommunitiesValue = this.dom.$form.querySelector('[name="NearbyCommunities"]')?.value;
    const contextCommunity = this.dom.$form.querySelector('[name="ContextCommunity"]')?.value;

    if (zipCode && zipCode.value && !nearbyCommunitiesValue && !contextCommunity) {
      zipCode.pristine.errors = [];
      zipCode.pristine.self.addError(zipCode, zipCode.dataset.errorMessage);
      return;
    }
  }

  getResults() {
    Coveo.$$(this.el).on('deferredQuerySuccess', (e, args) => {
      this.enableSubmitButton();

      if (this.lat && this.long) {
        const results = args.results.results;
        if (!results.length) this.showZipError();

        this.dom.$contextCommunityInput.value = results[0]
          ? results[0].raw.ssl_communityid
          : '';

        if (!this.isSecondQuery) {
          let inputValue = '';

          results.map((el, i) => {
            const id = el.raw.ssl_communityid;
            if (id && results.length - 1 !== i) {
              inputValue += `${id}, `;
            } else if (id) {
              inputValue += `${id}`;
            }
          });
          this.dom.$communityInput.setAttribute('value', inputValue);
          this.dom.$communityInput.value = inputValue;
        }

        if (!this.contextCommunity) {
          this.dom.$communityDistance.value = (results[0].raw.distance * this.metersToMiles).toFixed(2);
        } else {
          if (!this.closedQuery) {
            this.isSecondQuery = true;

            Coveo.logSearchEvent(
              this.el, {
                name: 'communityContactUs',
                type: ''
              }, {}
            );

            Coveo.executeQuery(this.el);
          }
          this.dom.$communityDistance.value = (results[0].raw.distance * this.metersToMiles).toFixed(2);
        }
        this.formHandler();
      } else {
        this.showZipError();
      }
    });
  }

  configureEndpoint() {
    if (this.el.dataset.organizationId.length > 0) {
      this.organizationId = this.el.dataset.organizationId;
      Coveo.SearchEndpoint.configureCloudV2Endpoint(
        this.organizationId,
        this.apiKey
      );
    }
  }

  formHandler(e) {
    if (this.contextCommunity) {
      const parsedContextCommunity = JSON.parse(this.contextCommunity);
      this.dom.$contextCommunityInput.value = parsedContextCommunity.ssl_communityid;
    }
  }

  getGeoQuery(lat, long) {
    return `$qf(function:'dist(@ssl_latitude_d,@ssl_longitude_d,${lat},${long})', fieldName: 'distance')`;
  }

  addListeners() {
    const zip = this.el.querySelector('.community-contact-us__zip input');
    if (zip) {
      zip.addEventListener('blur', ev => {
        this.disableSubmitButton();
        this.fetchLocation(ev);
      });
    }

    if (this.dom.$topics) {
      this.dom.$topics._on('change', this.handleTopicChange.bind(this));
    }

    if (this.dom.$datePicker) {
      this.dom.$datePicker.addEventListener('duetChange', event => {
        this.currentDate = event.detail.valueAsDate;
        this.timeHandler();
      });

      this.dom.$datePicker.addEventListener('duetBlur', event => {
        const $input = this.dom.$datePicker.querySelector('input');
        const splited = this.dom.$datePicker.value.split('-');
        $input.value = `${this.checkZero(splited[1])}/${this.checkZero(splited[2])}/${splited[0]}`;
      });
    }
  }

  checkZero(value) {
    if (value.split('')[0] === '0') return value.split('')[1];

    return value;
  }

  fetchLocation(e) {
    this.resetSetup();
    const zip = this.el.querySelector('.community-contact-us__zip input').value;

    fetch(`${this.el.dataset.geoEndpoint}?value=${zip}`)
      .then(res => res.json())
      .then(data => {
        this.lat = data.Latitude;
        this.long = data.Longitude;

        Coveo.logSearchEvent(
          this.el, {
            name: 'communityContactUs',
            type: ''
          },
          {
            latitude: this.lat,
            longitude: this.long
          }
        );

        Coveo.executeQuery(this.el);
      })
      .catch(e => {
        this.lat = null;
        this.long = null;

        Coveo.logSearchEvent(
          this.el, {
            name: 'communityContactUsError',
            type: ''
          },
          {
            latitude: this.lat,
            longitude: this.long
          }
        );

        Coveo.executeQuery(this.el);
      });
  }

  enableSubmitButton() {
    this.dom.$submitButton.classList.remove('community-contact-us__submit--disabled');
  }

  disableSubmitButton() {
    this.dom.$submitButton.classList.add('community-contact-us__submit--disabled');
  }

  resetSetup() {
    this.firstCommunity = false;
    this.isRadiusLarge = false;
    this.dom.$contextCommunityInput.value = '';
    this.dom.$communityInput.value = '';
    this.dom.$communityDistance.value = '';
    this.isSecondQuery = false
    this.closedQuery = false
  }

  verifyQueryParams() {
    const urlParams = new URLSearchParams(window.location.search);

    // IF BE sends query param book a tour true, scroll to the form and set the select option to book a tour
    if (urlParams.has('bookatour') && urlParams.get('bookatour') === 'true') {
      const yOffset = -40;
      const y =
        this.el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      const select = this.dom.$topics.querySelector('select');
      const selectValuesToSearch = [
        'schedule-tour',
        'book-a-tour',
        'SCHEDULEVISIT'
      ];
      const e = new Event('change');

      window.scrollTo({ top: y, behavior: 'smooth' });

      [...select.options].forEach(option => {
        if (selectValuesToSearch.includes(option.value)) {
          select.value = option.value;
          select.dispatchEvent(e);
          this.handleTopicChange(e);
        }
      });
    }
  }

  handleTopicChange(e) {
    this.el.classList.toggle(
      this.preferredTimesShownClass,
      e.target.value === this.preferredTimesTopicValue
    );
  }
}

export default Module;
